import type { BannerRepository } from '../../domain/repositories/BannerRepository.interface';
import type { BannerDto } from '../dto/BannerDto';

export class GetActiveBannerUseCase {
  constructor(private readonly repository: BannerRepository) {}

  public async execute(): Promise<BannerDto | null> {
    const banner = await this.repository.getActive();
    return banner ? banner.props : null;
  }
}
